module.exports = require("stream-chat-react");